<div class="padding flex column fix-height">
  <div class="flex between center">
    <b class="margin-bottom-small">{{ title }}</b>

    <span class="flex center primary hover" (click)="copyToClipboard(list.join(', '))">
      Copy all
      <i class="fa-solid fa-copy margin-left-smallest"></i>
    </span>
  </div>

  <div class="flex column margin-top-small flex-1 scrollable">
    @for (item of list; track $index) {
      <div class="padding-small bg-light-grey unicode">{{ item }}</div>
    }
    @if (!list.length) {
      <div class="padding-small grey">No items</div>
    }
  </div>

  <div class="flex column end margin-top-small">
    <div class="flex center">
      <button class="stroked" (click)="close()">
        <i class="fa-solid fa-check margin-right-small"></i>
        Close
      </button>
    </div>
  </div>
</div>
